import { Base } from './base';
import { AppUtils } from './appUtils';
export var APP;
(function (APP) {
    APP["qb"] = "qb";
    APP["kb"] = "kb";
})(APP || (APP = {}));
export class Vision extends Base {
    checkAppInstalled(appName, callback) {
        if (this.isWX) {
            this.wxCheckInstall(appName, callback);
        }
        else if (this.isQQ) {
            this.qqCheckInstall(appName, callback);
        }
        else {
            return callback(false);
        }
    }
    wxCheckInstall(appName = APP.qb, callback) {
        this.reporter({
            scene: 'checkWXInstall',
            msg: this.config.qbPackagename
        });
        let pkgName = this.config.qbPackagename;
        let scheNameUrl = this.config.qbSchema;
        if (appName === APP.kb) {
            pkgName = this.config.kbPackageName;
            scheNameUrl = this.config.kbSchemaName + '://';
        }
        AppUtils.checkWXJSApi(() => {
            window.WeixinJSBridge.invoke('getInstallState', {
                packageUrl: scheNameUrl,
                packageName: pkgName
            }, (results) => {
                if (/get_install_state:yes/ig.test(JSON.stringify(results)) === true) {
                    callback && callback(true);
                }
                else {
                    callback && callback(false);
                }
            });
        });
    }
    qqCheckInstall(appName = APP.qb, callback) {
        let pkgName = this.config.qbPackagename;
        let scheName = 'mttbrowser';
        this.reporter({
            scene: 'checkQQInstall',
            msg: this.config.qbPackagename
        });
        if (appName === APP.kb) {
            pkgName = this.config.kbPackageName;
            scheName = this.config.kbSchemaName;
        }
        if (this.isAndroid) {
            window.mqq.app.checkAppInstalled(pkgName, function (ret) {
                if (!ret || ret != '0') {
                    callback(true, 0, ret);
                }
                else {
                    callback(false, 0, null);
                }
            });
        }
        else if (this.isIos) {
            window.mqq.app.isAppInstalled(scheName, function (results) {
                if (results === true || (results && results.result === true)) {
                    callback(true, 0, null);
                }
                else {
                    callback(false, 0, null);
                }
            });
        }
        else {
            callback && callback(false);
        }
    }
}
//# sourceMappingURL=vision.js.map